import { stripPathLocale } from '../../common/localeShared';
import { getRoutesMatches, TRouteDef } from './router/router-helpers';

type THydrationErrorReporter = {
  error(message: string, context: THydrationErrorContext): void;
};

type THydrationErrorContext = {
  kind: 'react_hydration_recovery';
  game: string;
  release: string;
  route: string;
  ssrMode: string;
};

type TCreateHydrationErrorOptions = {
  routes: TRouteDef[];
  game: string;
  release: string;
  pathname?: string;
  isDevelopment?: boolean;
  getReporter?: () => THydrationErrorReporter | undefined;
};

const normalizeRouteTemplate = (route: string | undefined): string => {
  if (!route) {
    return 'unmatched';
  }
  const normalized = `/${route}`.replace(/\/+/g, '/');
  return normalized.length > 1 ? normalized.replace(/\/$/, '') : normalized;
};

export function createHydrationErrorOptions({
  routes,
  game,
  release,
  pathname = window.location.pathname,
  isDevelopment = false,
  getReporter = () => (window as any).Rollbar
}: TCreateHydrationErrorOptions) {
  const matches = getRoutesMatches(routes, stripPathLocale(pathname));
  const leafRoute = matches[matches.length - 1]?.route;
  const context: THydrationErrorContext = {
    kind: 'react_hydration_recovery',
    game,
    release,
    route: normalizeRouteTemplate(leafRoute?.path),
    ssrMode: leafRoute?.ssrMode || leafRoute?.component?.ssrMode || 'unknown'
  };

  return {
    onRecoverableError(error: unknown) {
      getReporter()?.error('React hydration recoverable error', context);
      if (isDevelopment) {
        // Local-only detail helps development without transmitting React's
        // hydration diff, which can contain rendered user data.
        console.error('React hydration recoverable error', error);
      }
    }
  };
}
